export default __webpack_public_path__ + "static/media/image94.f1b246a5.png";